import React, { useCallback } from 'react';
import { Button, Badge } from 'react-bootstrap';
import { useDiagramStore } from '../store/diagramStore';

interface Props {
  onExportPdf: () => void;
}

const ToolbarPanel: React.FC<Props> = ({ onExportPdf }) => {
  const validate = useDiagramStore(s => s.validate);
  const rebuildDiagram = useDiagramStore(s => s.rebuildDiagram);
  const collisions = useDiagramStore(s => s.collisions);
  const scenarios = useDiagramStore(s => s.scenarios);
  const saveToApi = useDiagramStore(s => s.saveToApi);

  const handleRefresh = useCallback(() => {
    const errors = validate();
    if (errors.length === 0) {
      rebuildDiagram();
    }
  }, [validate, rebuildDiagram]);

  const handleSave = useCallback(async () => {
    await saveToApi();
  }, [saveToApi]);

  const handleExportJson = useCallback(() => {
    const visible = scenarios.filter(s => s.visible);
    if (visible.length === 0) return;

    const exportData = visible.map(sc => sc.diagram);
    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `diagrams-${new Date().toISOString().slice(0, 10)}.json`;
    a.click();
    URL.revokeObjectURL(url);
  }, [scenarios]);

  const visibleCount = scenarios.filter(s => s.visible).length;

  return (
    <div style={{
      height: 48,
      background: '#fff',
      borderBottom: '1px solid #E0E0E0',
      display: 'flex',
      alignItems: 'center',
      padding: '0 16px',
      gap: 12,
      flexShrink: 0,
      zIndex: 20,
    }}>
      <strong style={{ fontSize: 14 }}>Диаграммы процессов</strong>
      <Badge bg="primary">{visibleCount} / {scenarios.length}</Badge>

      {collisions.length > 0 && (
        <Badge bg="danger">{collisions.length} коллизий</Badge>
      )}

      <div style={{ flex: 1 }} />

      <Button size="sm" variant="outline-secondary"
        style={{ fontSize: '0.75rem' }}
        onClick={handleRefresh}>
        Обновить
      </Button>
      <Button size="sm" variant="outline-primary"
        style={{ fontSize: '0.75rem' }}
        onClick={handleSave}>
        Сохранить
      </Button>
      <Button size="sm" variant="outline-secondary"
        style={{ fontSize: '0.75rem' }}
        onClick={handleExportJson}>
        JSON
      </Button>
      <Button size="sm" variant="outline-secondary"
        style={{ fontSize: '0.75rem' }}
        onClick={onExportPdf}>
        PDF
      </Button>
    </div>
  );
};

export default ToolbarPanel;
